import { TAB_IDS } from "../constants/tabs";

/**
 * Factory that builds the `onNavigate` callback for the HelpAssistant.
 * Kept out of App.js because the whitelist logic + CustomEvent dispatch
 * are pure — they don't need to render anything, only mutate the
 * dashboard state passed in via callbacks.
 *
 * Route contract (matches HelpAssistant.py return schema):
 *   • "overview" | "editor" | ...  → jump to a top-level tab
 *   • "menu:bulk_deworming"        → open Schedule tab + fire ych:open event
 *   • "menu:bulk_supplement"       → jump to Data Editor
 *   • "menu:*" | "growth_chart"    → fire ych:open CustomEvent for modal owner
 *   • anything else                → no-op (safer than throwing on stray CTAs)
 */
export default function makeHelpAssistantNavigate({ setTab, setSelectedId }) {
  return function onNavigate(cta) {
    const route = cta.route;
    const params = cta.params || {};
    if (TAB_IDS.includes(route)) {
      setTab(route);
      if (params.sailor_id) setSelectedId(params.sailor_id);
      return;
    }
    if (route === "menu:bulk_deworming") {
      setTab("schedule");
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("ych:open", { detail: { route, params } }));
      }, 60);
      return;
    }
    if (route === "menu:bulk_supplement") {
      // Bulk Supplements lives inside the per-athlete Data Editor
      // toolbar. Navigate there; coach then clicks the button.
      setTab("editor");
      return;
    }
    if (route.startsWith("menu:") || route === "growth_chart") {
      window.dispatchEvent(new CustomEvent("ych:open", { detail: { route, params } }));
    }
  };
}
